var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 41,
    viewBox: "0 0 27 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.5015 0H6.75025C4.95998 0 3.24302 0.711185 1.9771 1.9771C0.711186 3.24302 0 4.95997 0 6.75025C0 8.54053 0.711186 10.2575 1.9771 11.5234C3.24302 12.7893 4.95998 13.5005 6.75025 13.5005H13.5015V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5015 13.5005H6.75023C4.96022 13.5005 3.24352 14.2116 1.97779 15.4773C0.712066 16.7431 0.000988007 18.4597 0.000988007 20.2498C0.000988007 22.0398 0.712066 23.7565 1.97779 25.0222C3.24352 26.2879 4.96022 26.999 6.75023 26.999H13.5015V13.5005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.2497C27 22.04 26.2888 23.757 25.0229 25.0229C23.757 26.2888 22.04 27 20.2498 27C18.4595 27 16.7425 26.2888 15.4766 25.0229C14.2107 23.757 13.4995 22.04 13.4995 20.2497C13.4995 18.4595 14.2107 16.7425 15.4766 15.4766C16.7425 14.2107 18.4595 13.4995 20.2498 13.4995C22.04 13.4995 23.757 14.2107 25.0229 15.4766C26.2888 16.7425 27 18.4595 27 20.2497Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.75025 27.001H13.5015V33.7502C13.5011 35.0849 13.105 36.3895 12.3632 37.4991C11.6214 38.6087 10.5673 39.4735 9.33416 39.9841C8.10098 40.4946 6.7441 40.6281 5.43506 40.3676C4.12603 40.1072 2.92361 39.4644 1.97984 38.5206C1.03606 37.5768 0.393301 36.3744 0.132815 35.0654C-0.12767 33.7564 0.00581705 32.3995 0.5164 31.1663C1.02698 29.9331 1.89173 28.879 3.00133 28.1372C4.11093 27.3955 5.41554 27.0014 6.75025 27.001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.4995 0H20.2487C22.039 0 23.756 0.711185 25.0219 1.9771C26.2878 3.24302 26.999 4.95997 26.999 6.75025C26.999 8.54053 26.2878 10.2575 25.0219 11.5234C23.756 12.7893 22.039 13.5005 20.2487 13.5005H13.4995V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill1);
export default __webpack_public_path__ + "static/media/skill (1).794ff3c055d453d6ab03e1ec41a26df6.svg";
export { ForwardRef as ReactComponent };